import request, { authorizedRequest } from '../utils/request';

export function fetchRecommendationQuestions(params) {
    return request.get('/ai/recommendations/questions', params);
}
export function saveRecommendationQuestion(item) {
    return authorizedRequest('POST', '/ai/recommendations/questions/save', { data: { item } });
}
export function deleteRecommendationQuestion(id) {
    return authorizedRequest('DELETE', `/ai/recommendations/questions/${id}`);
}
export function fetchRecommendationTags() {
    return request.get('/ai/recommendations/tags');
}
export function renameRecommendationTag(data) {
    return authorizedRequest('POST', '/ai/recommendations/tags/rename', { data });
}
export function startRecommendationTranslation(scope) {
    return authorizedRequest('POST', '/ai/recommendations/translations/start', { data: { scope, overwrite: true } });
}
export function fetchRecommendationTranslationJob(jobId = '') {
    return request.get('/ai/recommendations/translations/job', { jobId });
}
export function saveRecommendationTranslation(data) {
    return authorizedRequest('POST', '/ai/recommendations/translations/save', { data });
}
